import React from 'react';
import { Grid,useMediaQuery, Container, Box, Typography, TextField, Button,} from '@mui/material';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaYoutube, FaInstagram, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import logo from '../assests/images/logo-white.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
const Footer = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleSubscribe = () =>{
    
  }
  return (
    <footer className="footer text-light pt-4"  >
      <Grid  container sx={{padding: isSmallScreen ? '2rem' : '3rem 6rem 0',}} >
        <Grid container spacing={4} justifyContent="center">
          
          {/* Widget 3 */}
<Grid item xs={12} md={4} container direction="column" alignItems="start">
<Typography variant="h5" mb={2}>About</Typography>
  <Typography 
    variant="h6" 
    align="start" 
    className='heading'
    sx={{ 
     
      fontWeight: 'bold', 
      color: 'grey' 
    }}
  >
    Welcome to Chef Adel's Culinary World!
  </Typography>
  <Typography  
  className='body'
    variant="body1" 
    align="start" 
    sx={{ 
      marginTop: '0.5rem', 
      fontStyle: 'italic', 
      color: 'gray' 
    }}
  >
I’m Chef Adel, passionate about crafting unforgettable dishes and elevating the dining experience. Explore exclusive recipes, cutting-edge techniques, and tips for restaurant-quality meals at home.

I also offer services like restaurant management, staff training, and more. Open to collaborations and business opportunities—let’s create something extraordinary together!

  </Typography>
  
 

</Grid>

         
          {/* Widget 2: Logo and Links */}
          <Grid item xs={12} md={4} container direction="column" alignItems="center">
            <img src={logo} alt="Logo" style={{ width: '200px' }} />
            <Box mt={2}>
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Link to="/" className='link' color="inherit" underline="hover">Home</Link>
                </Grid>
                <Grid item>
                  <Link to="/services" className='link'  color="inherit" underline="hover">Services</Link>
                </Grid>
                <Grid item>
                  <Link to="/about" className='link' color="inherit" underline="hover">About</Link>
                </Grid>
                <Grid item>
                  <Link to="/contact" className='link' color="inherit" underline="hover">Contact</Link>
                </Grid>
                <Grid item>
                  <Link to="/blog" className='link' color="inherit" underline="hover">Blog</Link>
                </Grid>
              </Grid>
            </Box>
            <Box mt={2} display="flex" justifyContent="center" gap={2}>
            <Link to="https://www.instagram.com/chef.adel.aljaadi?igsh=cmZuc3N2NXFnZm94" target="_blank" rel="noopener noreferrer" style={{color: 'white'}} >
              <InstagramIcon className="social-icon" />
            </Link>

            <Link to="https://www.facebook.com/chef.adel.aljaadi?mibextid=LQQJ4d" target="_blank"  rel="noopener noreferrer" style={{color: 'white'}}>
              <FacebookIcon className="social-icon" />
            </Link>

            <Link to="https://www.linkedin.com/in/adel-aljaadi-6822b232a" target="_blank" rel="noopener noreferrer" style={{color: 'white'}}>
              <LinkedInIcon className="social-icon" />
            </Link>
              </Box>

          </Grid>

          {/* Widget 1: Contact Us */}
          <Grid item xs={12} md={4} container direction="column">
            <Typography variant="h5" mb={2}>Contact Me</Typography>
            <Typography variant="body-1" mb={2} justifyContent="center">
              <address className='grey-color'>
                <Link className='link' href="https://maps.app.goo.gl/Ux5q3nZZWUdyMCLV9" color="inherit" underline="hover">
                 
                  Muscat, Oman
                </Link>
                <br /><br />
                <Link className='link' to="https://api.whatsapp.com/send?phone=601133366914" target='_blank' color="inherit" underline="hover" display="flex" alignItems="center">
                  <FaPhoneAlt /> <span style={{ marginLeft: '8px' }}>+96871701233</span>
                </Link>
                <br />
                <Link className='link' to="mailto:chef.adel.aljaadi@gmail.com" target='_blank' color="inherit" underline="hover" display="flex" alignItems="center">
                  <FaEnvelope /> <span style={{ marginLeft: '8px' }}>chef.adel.aljaadi@gmail.com</span>
                </Link>
              </address>
            </Typography>

            {/* Newsletter Subscription Section */}
            {/* <Typography variant="h5" mt={4} mb={2}>Subscribe to My Newsletter</Typography>
            <Typography variant="body-1" mb={2}>
              Don’t miss out on personalized recipe recommendations, cooking tips, and exclusive updates from Chef Adel’s blog. By subscribing, you’ll receive hand-picked insights directly to your inbox, tailored to help you elevate your culinary skills and dining experience.
            </Typography>
            
            <Box component="form" onSubmit={handleSubscribe} sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mt: 2 }}>
              <TextField label="Enter your email" variant="outlined" fullWidth required />
              <Button variant="contained" type="submit">Subscribe Now</Button>
            </Box> */}
          </Grid>






        </Grid>

    {/* Footer Bottom */}
<Grid
  container
  justifyContent="center"
  className="text-center mt-4 pt-3 gray-border"
  spacing={1} // Adds some space between the rows
>
  {/* First Row - Copyright Text */}
  <Grid
    item
    xs={12} // Takes full width on small screens
    sm="auto" // Auto width on medium and larger screens
    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
  >
    <Typography
      variant="body2"
      sx={{ textAlign: 'center' }} // Centers text
    >
      &copy; 2024 Abu Shadi. All rights reserved.
    </Typography>
  </Grid>

  {/* Second Row - Developer Link */}
  <Grid
    item
    xs={12} // Takes full width on small screens
    sm="auto" // Auto width on medium and larger screens
    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
  >
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      Developed By
      <span>&nbsp;</span>
      <Link
        className='link blue-text'
        to="https://aziz-dev-qois.vercel.app"
        target="_blank" // Open the link in a new tab
        rel="noopener noreferrer" // Prevent security vulnerabilities
        style={{ textDecoration: 'none', marginLeft: '4px' }}
      >
        @Aziz Div
      </Link>
    </Typography>
  </Grid>
</Grid>

      </Grid>
    </footer>
  );
};

export default Footer;
